import { Home5 } from "../pages/tema5/Home5";
import { IntroductionTema5 } from "../pages/tema5/introductionTema5";
import { Tema5SubtopicOneActivityOne } from "../pages/tema5/TopicOne/Tema5SubtopicOneActivityOne";
import { Tema5SubtopicOneActivityTwo } from "../pages/tema5/TopicOne/Tema5SubtopicOneActivityTwo";
import { Tema5SubtopicOneFinalPoint } from "../pages/tema5/TopicOne/Tema5SubtopicOneFinalPoint";
import { Tema5SubtopicTwoActivityOne } from "../pages/tema5/TopicTwo/Tema5SubtopicTwoActivityOne";
import { Tema5SubtopicTwoActivityTwo } from "../pages/tema5/TopicTwo/Tema5SubtopicTwoActivityTwo";
import { Tema5SubtopicTwoFinalPoint } from "../pages/tema5/TopicTwo/Tema5SubtopicTwoFinalPoint";
import { Tema5SubtopicThreeActivityOne } from "../pages/tema5/TopicThree/Tema5SubtopicThreeActivityOne";
import { Tema5SubtopicThreeActivityTwo } from "../pages/tema5/TopicThree/Tema5SubtopicThreeActivityTwo";
import { Tema5SubtopicThreeActivityThree } from "../pages/tema5/TopicThree/Tema5SubtopicThreeActivityThree";
import { Tema5SubtopicThreeFinalPoint } from "../pages/tema5/TopicThree/Tema5SubtopicThreeFinalPoint";
import { Tema5SubtopicFourActivityOne } from "../pages/tema5/TopicFour/Tema5SubtopicFourActivityOne";
import { Tema5SubtopicFourFinalPoint } from "../pages/tema5/TopicFour/Tema5SubtopicFourFinalPoint";
import { SubtopicFinalTema5 } from "../pages/tema5/SubtopicFinalTema5";

export const pathTema5 = {
	path: "home5",
	element: <Home5 />,
	children: [
		{
			path: "tema5",
			children: [
				{
					path: 'introduction',
					element: <IntroductionTema5 />,
				},
				{
					path: 'subtema1',
					children: [
						{
							path: 'activityOne',
							element: <Tema5SubtopicOneActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema5SubtopicOneActivityTwo />
						},
						{
							path: "results",
							element: <Tema5SubtopicOneFinalPoint />,
						},
					]
				},
				{
					path: 'subtema2',
					children: [
						{
							path: 'activityOne',
							element: <Tema5SubtopicTwoActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema5SubtopicTwoActivityTwo />
						},
						{
							path: "results",
							element: <Tema5SubtopicTwoFinalPoint />,
						},
					]
				},
				{
					path: 'subtema3',
					children: [
						{
							path: 'activityOne',
							element: <Tema5SubtopicThreeActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema5SubtopicThreeActivityTwo />
						},
						{
							path: 'activityThree',
							element: <Tema5SubtopicThreeActivityThree />
						},
						{
							path: "results",
							element: <Tema5SubtopicThreeFinalPoint />,
						},
					]
				},
				{
					path: 'subtema4',
					children: [
						{
							path: 'activityOne',
							element: <Tema5SubtopicFourActivityOne />
						},
						{
							path: "results",
							element: <Tema5SubtopicFourFinalPoint />,
						},
					]
				},
				{
					path: "final",
					element: <SubtopicFinalTema5 />,
				},
			]
		}
	]
}